import { Card, Statistic, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CountUp from "react-countup";

const COLORS = {
  income: "#52c41a",
  expenses: "#ff4d4f",
  profit: "#1890ff",
  warning: "#fa8c16",
  neutral: "#666",
};

function StatCard({ title, value, prefix = "$", type = "neutral", suffix, loading, tooltip }) {
  const color = COLORS[type] || COLORS.neutral;

  const formatter = (val) => (
    <CountUp end={val} separator="," decimals={0} duration={1} />
  );

  const titleWithTooltip = tooltip ? (
    <span>
      {title}{" "}
      <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ color: "#999", cursor: "help" }} />
      </Tooltip>
    </span>
  ) : (
    title
  );

  return (
    <Card className="text-center" loading={loading}>
      <Statistic
        title={titleWithTooltip}
        value={value}
        prefix={prefix}
        suffix={suffix}
        formatter={formatter}
        valueStyle={{ color, fontSize: "1.5rem", fontWeight: "bold" }}
      />
    </Card>
  );
}

export default StatCard;
